import { jsx } from "react/jsx-runtime";
import { iconFactory } from "./Icon.js";
const IconSuccess = iconFactory('IconSuccess', /*#__PURE__*/ jsx("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    "data-icon-type": "fill",
    children: /*#__PURE__*/ jsx("path", {
        d: "M12,3 C16.9707,3 21,7.0293 21,12 C21,16.9707 16.9707,21 12,21 C7.0293,21 3,16.9707 3,12 C3,7.0293 7.0293,3 12,3 Z M15.7123106,8.65165043 L10.9393398,13.4246212 L8.2876894,10.7729708 L6.69669914,12.363961 L10.9393398,16.6066017 L17.3033009,10.2426407 L15.7123106,8.65165043 Z"
    })
}));
export { IconSuccess };
